import type { ComponentProps } from 'react';

import { Modal } from '@arco-design/web-react';

type PluginModalProps = ComponentProps<typeof Modal>;

/** delivery-type-plugin 弹窗：默认禁止点击遮罩关闭 */
export function PluginModal({ maskClosable = false, ...props }: PluginModalProps) {
  return <Modal maskClosable={maskClosable} {...props} />;
}
